/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1AssociatedcompanyCompanySizesDropdown200,
  GetApiV1AssociatedcompanyCompanySizesDropdown401,
  GetApiV1AssociatedcompanyCompanySizesDropdown500,
  GetApiV1AssociatedcompanyCompanySizesDropdownQueryResponse,
} from "../../types/associatedCompanySharedController/GetApiV1AssociatedcompanyCompanySizesDropdown.ts";
import { dropDownListViewModelSchema } from "../dropDownListViewModelSchema.ts";

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1AssociatedcompanyCompanySizesDropdown200Schema = z.array(
  z.lazy(() => dropDownListViewModelSchema),
) as unknown as ToZod<GetApiV1AssociatedcompanyCompanySizesDropdown200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1AssociatedcompanyCompanySizesDropdown401Schema =
  z.any() as unknown as ToZod<GetApiV1AssociatedcompanyCompanySizesDropdown401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1AssociatedcompanyCompanySizesDropdown500Schema =
  z.any() as unknown as ToZod<GetApiV1AssociatedcompanyCompanySizesDropdown500>;

export const getApiV1AssociatedcompanyCompanySizesDropdownQueryResponseSchema =
  z.lazy(
    () => getApiV1AssociatedcompanyCompanySizesDropdown200Schema,
  ) as unknown as ToZod<GetApiV1AssociatedcompanyCompanySizesDropdownQueryResponse>;
